import './Header.css'
import { useNavigate } from 'react-router-dom';

const Header = ({ videoSelected, onVideo }) => {
    const navigate = useNavigate();

    const handleWorkClick = (isSelected) => {

        setTimeout(() => {
            videoSelected(isSelected);
            navigate('/work');
        }, 600);
    };

    return (
        <div className="header">
            <ul className={`header-ul spacing`}>
                <div className={`header-name ${onVideo ? 'onVideo' : ''}`}>
                    <li>
                        <a href="/" onClick={(e) => { e.preventDefault(); videoSelected(false); navigate('/'); }}>
                            {/* <img className="sebas-logo" src={`${process.env.PUBLIC_URL}/SEBAS_COTO_MENU_LOGO.png`} /> */}
                            <span style={{fontWeight: "bold"}}>SEBAS</span>COTO_
                        </a>
                    </li>
                </div>
                <div className={`work-text ${onVideo ? 'onVideo' : ''}`}>
                    <li><a href="/work" onClick={(e) => { e.preventDefault(); handleWorkClick(); }}>WORK</a></li>
                </div>
            </ul>
        </div>
    );
};

export default Header;
